var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-upload"},[_c('spinner',{attrs:{"spinnerText":"上传中。。。"},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}}),_vm._v(" "),_c('el-upload',{attrs:{"action":"~","http-request":_vm.httpRequest,"show-file-list":false}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }